module.exports = __webpack_public_path__ + "static/img/WechatPay.b324f90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WechatPay/WechatPay.png
// module id = eSEs
// module chunks = 4